module.exports = __webpack_public_path__ + "img/spinach-cheese-bake.23c458df.jpg";